import { all } from 'redux-saga/effects'
import { updateSaga } from './update/saga'
import { companyLogoSaga } from './company-logo/sagas'
import { companyBannerSaga } from './company-banner/sagas'

export function* employerSaga() {
  yield all([updateSaga(), companyLogoSaga(), companyBannerSaga()])
}
